export enum CarCategory {
    SUV = 'SUV',
    ECONOMY = 'Economy',
    SEDAN = 'Sedan',
}
